import { getCleanCanvasContext } from './heatmapCanvasRenderer';

const COLORS = Object.freeze({
  3: 'rgba(179,42,0, 0.70)',
  2: 'rgba(255,60,0, 0.50)',
  1: 'rgba(255,216,204, 0.50)',
});

function getZoneXYCoords(
  zone: HeatmapAPI.EngagementZone,
  zoneSize: number,
): { x: number; y: number } {
  return {
    x: zone.col * zoneSize,
    y: zone.row * zoneSize,
  };
}

function drawZones({
  context,
  zoneSize,
  engagementGrid,
}: {
  context: CanvasRenderingContext2D;
  zoneSize: number;
  engagementGrid: HeatmapAPI.EngagementZone[];
}): void {
  engagementGrid.forEach((zone) => {
    context.fillStyle = COLORS[zone.score];
    context.strokeStyle = 'white';
    const { x, y } = getZoneXYCoords(zone, zoneSize);
    context.fillRect(x, y, zoneSize, zoneSize);
    context.strokeRect(x, y, zoneSize, zoneSize);
  });
}

export function renderEngagementZones(
  canvas: HTMLCanvasElement | null,
  engagementZones: HeatmapAPI.GetEngagementZonesData,
): void {
  if (canvas === null) return;

  const context = getCleanCanvasContext(canvas);

  drawZones({
    context,
    zoneSize: engagementZones.zoneSize,
    engagementGrid: engagementZones.engagementGrid,
  });
}
